module.exports = __webpack_public_path__ + "static/media/shell32_133.e69b9c0f.ico";